<template>
  <div>
    <form @submit.prevent="saveData()">
      <div v-for="(part, i) in schema" :key="i">
        <div v-for="(item, j) in part" :key="j" class="mt-3 row">
          <div class="col-12 col-md-4 label">{{ item.label }}</div>
          <div class="col-12 col-md-8">
            <date-picker
              v-if="item.model === 'idcard_validity'"
              v-model="model[item.model]"
              :input-props="{
                placeholder: 'Vyberte dátum',
                class:
                  personalInfo[item.model] !== model[item.model]
                    ? 'form-control changed-value'
                    : 'form-control',
                required: true
              }"
            />
            <input
              v-else
              type="text"
              v-model="model[item.model]"
              class="form-control"
              :class="
                personalInfo[item.model] !== model[item.model]
                  ? 'changed-value'
                  : ''
              "
              :required="item.required"
            />
          </div>
        </div>
      </div>

      <div
        class="mt-5"
        v-if="
          personalInfo.representatives.length > 0 &&
            model.representatives.length > 0
        "
      >
        <h5 class="color-gray font-weight-bold">Oprávnená osoba</h5>
        <div v-for="(item, i) in representative" :key="i" class="mt-3 row">
          <div class="col-12 col-md-4 label">{{ item.label }}</div>
          <div class="col-12 col-md-8">
            <input
              type="text"
              v-model="model.representatives[0][item.model]"
              class="form-control"
              :class="
                personalInfo.representatives[0][item.model] !==
                model.representatives[0][item.model]
                  ? 'changed-value'
                  : ''
              "
              :required="item.required"
            />
          </div>
        </div>
      </div>

      <div class="mt-5" v-if="showDocuments">
        <h5 class="color-gray font-weight-bold">Dodatočné doklady</h5>
        <div class="mt-3 row">
          <b-form-radio-group
            v-model="model.idcard_type_id"
            :required="true"
            buttons
            button-variant="outline-warning"
            class="col-12 w-100"
          >
            <b-form-radio :value="2" class="w-50">
              <font-awesome-icon icon="id-card" class="mr-2" />
              Občiansky preukaz
            </b-form-radio>
            <b-form-radio :value="1" class="w-50">
              <font-awesome-icon icon="passport" class="mr-2" />
              PAS
            </b-form-radio>
          </b-form-radio-group>
        </div>

        <div class="mt-3 row">
          <div class="col-12 col-md-4 label">
            {{ model.idcard_type_id === 1 ? "Pas" : "Občiansky preukaz" }}
          </div>
          <div class="col-12 col-md-8">
            <b-form-file
              :placeholder="
                model.idcard_type_id === 1
                  ? 'Nahrajte pas'
                  : 'Nahrajte prednú stranu OP'
              "
              drop-placeholder="Presuňte súbor sem"
              @change="readFile('doc1_front', $event)"
              required
            ></b-form-file>
            <b-form-file
              v-if="model.idcard_type_id === 2"
              class="mt-3 form-control-file"
              placeholder="Nahrajte zadnú stranu OP"
              drop-placeholder="Presuňte súbor sem"
              @change="readFile('doc1_back', $event)"
              required
            ></b-form-file>
          </div>
        </div>
      </div>

      <div class="text-center mt-5 mb-2">
        <button type="submit" class="btn btn-warning">
          <font-awesome-icon v-if="loading" icon="spinner" class="mr-1" spin />
          Odoslať žiadosť o zmenu osobných údajov
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import DatePicker from "v-calendar/lib/components/date-picker.umd";
export default {
  name: "ChangePersonalInfo",
  components: {
    DatePicker
  },
  mounted() {
    this.model = JSON.parse(JSON.stringify(this.personalInfo));
    this.personalInfo.idcard_validity = this.model.idcard_validity = new Date(
      this.personalInfo.idcard_validity
    );
  },
  computed: {
    personalInfo() {
      return this.$store.state.account.profileInfo;
    },
    showDocuments() {
      const personal = this.schema.personal;
      const representative = this.representative;

      if (this.personalInfo.person_type_id === 1) {
        for (const i in personal) {
          if (
            this.personalInfo[personal[i].model] !==
            this.model[personal[i].model]
          ) {
            return true;
          }
        }
      } else {
        for (const i in representative) {
          if (
            this.personalInfo.representatives[0][representative[i].model] !==
            this.model.representatives[0][representative[i].model]
          ) {
            representative[i].changed = true;
            return true;
          }
        }
      }
      return false;
    }
  },
  methods: {
    saveData() {
      this.loading = true;
      this.getChanges();
      this.$store
        .dispatch("account/updateProfile", {
          changes: this.changes,
          files: [this.model.doc1_front, this.model.doc1_back]
        })
        .then(() => {
          this.$emit("changed");
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getChanges() {
      this.changes = [];

      for (const i in this.schema) {
        for (const j in this.schema[i]) {
          if (
            this.personalInfo[this.schema[i][j].model] !==
            this.model[this.schema[i][j].model]
          ) {
            // console.log(this.model[this.schema[i][j].model]);
            this.changes.push({
              label: this.schema[i][j].label,
              model: this.schema[i][j].model,
              value: this.model[this.schema[i][j].model]
            });
          }
        }
      }

      if (this.model.representatives.length > 0) {
        for (const i in this.representative) {
          if (
            this.personalInfo.representatives[0][
              this.representative[i].model
            ] !== this.model.representatives[0][this.representative[i].model]
          ) {
            this.changes.push({
              label: this.representative[i].label + " (oprávnená osoba)",
              model: this.representative[i].model,
              value: this.model.representatives[0][this.representative[i].model]
            });
          }
        }
      }

      if (this.personalInfo.idcard_type_id !== this.model.idcard_type_id) {
        this.changes.push({
          label: "Preukaz totožnosti",
          value: this.model.idcard_type_id === 1 ? "Pas" : "Občiansky preukaz"
        });
      }
    },
    readFile: function(item, ev) {
      const file = ev.target.files[0];
      const extension = file.name
        .split(".")
        .pop()
        .toLowerCase();
      const reader = new FileReader();
      reader.readAsArrayBuffer(file);
      reader.onloadend = e => {
        const arrayBuffer = e.target.result;
        const hex = Array.prototype.map
          .call(new Uint8Array(arrayBuffer), x =>
            ("00" + x.toString(16)).slice(-2)
          )
          .join("");
        this.model[item] = { extension, hex, type: item };
      };
    }
  },
  data() {
    return {
      loading: false,
      model: {},
      changes: [],
      schema: {
        personal: [
          {
            label: "Titul",
            model: "academic_title_before",
            required: false
          },
          {
            label: "Meno",
            model: "name",
            required: true
          },
          {
            label: "Priezvisko",
            model: "surname",
            required: true
          },
          {
            label: "Titul za menom",
            model: "academic_title_after",
            required: false
          },
          {
            label: "Číslo preukazu totožnosti",
            model: "idcard_no",
            required: false
          },
          {
            label: "Platnosť preukazu totožnosti",
            model: "idcard_validity",
            required: false
          },
          {
            label: "Ulica",
            model: "street",
            required: true
          },
          {
            label: "Mesto",
            model: "city",
            required: true
          },
          {
            label: "PSČ",
            model: "zip",
            required: true
          }
        ],
        contact: [
          {
            label: "E-mail",
            model: "email",
            required: true
          },
          {
            label: "Tel. číslo",
            model: "phone",
            required: true
          }
        ]
      },
      representative: [
        {
          label: "Meno",
          model: "name",
          required: true
        },
        {
          label: "Priezvisko",
          model: "surname",
          required: true
        },
        {
          label: "Adresa",
          model: "addressShort",
          required: true
        },
        {
          label: "Rodné číslo",
          model: "birthnumber",
          required: true
        }
      ],
      file: [
        {
          label: "Pas",
          placeholder: "Nahrajte pas",
          type: "file",
          model: "doc1_front",
          formWrapperClass: "col-md-12",
          accept: "image/jpeg, image/png, .pdf",
          required: true
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
.button-row {
  margin-top: -10px;

  small {
    display: block;
    line-height: 120%;
  }
}

.modal-body {
  .label {
    font-size: 16px;
    color: $light-gray;
    //padding-top: 6px;
    vertical-align: center;
  }
}
</style>
